'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('detail', {
      url: '/data/detail',
      template: '<detail></detail>'
    });
}



// WEBPACK FOOTER //
// ./client/app/detail/detail.routes.js